module.exports = __webpack_public_path__ + "img/Pop_img_hdbg.1ed736de.png";